import api from "../core/api";

const controllerName = "RedPanik";
const RedPanikApi = api.injectEndpoints({
    endpoints: (builder) => ({
        KullaniciPanikRedOkuma: builder.query<number, { organizasyonId: number, userId: number }>({
            query: (req) => ({
                url: `/${controllerName}/KullaniciPanikRedOkuma`,
                method: "GET",
                params: req,
            }),
        }),
        KullaniciPanikRedOkumaKontrol: builder.mutation<boolean, { hastaKimlikId: number }>({
            query: (req) => ({
                url: `/${controllerName}/KullaniciPanikRedOkumaKontrol`,
                method: "GET",
                params: req,
            }),
        })
    }),
});
export const {
    useKullaniciPanikRedOkumaQuery,
    useKullaniciPanikRedOkumaKontrolMutation,
} = RedPanikApi;